const guiColors = {
    'color-scheme': 'dark',

    'ui-primary': '#0d0d0f',
    'ui-secondary': '#16161a',
    'ui-tertiary': '#1f1f26',

    'ui-modal-overlay': '#000000cc',
    'ui-modal-background': '#121217',
    'ui-modal-foreground': '#e8e8ed',
    'ui-modal-header-background': '#1a1a20',
    'ui-modal-header-foreground': '#ffffff',

    'ui-white': '#0d0d0f',

    'ui-black-transparent': '#ffffff1a',

    'text-primary': '#e8e8ed',

    'menu-bar-background': '#14141a',

    'assets-background': '#0d0d0f',

    'input-background': '#1a1a20',

    'popover-background': '#16161a',

    'badge-background': '#1a2533',
    'badge-border': '#2a3a50',

    'fullscreen-background': '#0d0d0f',
    'fullscreen-accent': '#0d0d0f',

    'page-background': '#0d0d0f',
    'page-foreground': '#e8e8ed',

    'project-title-inactive': 'var(--ui-secondary)',
    'project-title-hover': '#ffffff2a',

    'link-color': '#5cb8ff',

    'filter-icon-black': 'invert(100%)',
    'filter-icon-gray': 'grayscale(100%) brightness(1.8)',
    'filter-icon-white': 'brightness(0) invert(100%)',

    'paint-filter-icon-gray': 'brightness(1.8)'
};

const blockColors = {
    insertionMarker: '#b0b0b8',
    workspace: '#14141a',
    toolboxSelected: '#1a1a20',
    toolboxText: '#c0c0c8',
    toolbox: '#0d0d0f',
    flyout: '#101015',
    scrollbar: '#404048',
    valueReportBackground: '#1a1a20',
    valueReportBorder: '#2a2a32',
    valueReportForeground: '#e8e8ed',
    contextMenuBackground: '#16161a',
    contextMenuBorder: '#ffffff15',
    contextMenuForeground: '#e8e8ed',
    contextMenuActiveBackground: '#1f1f26',
    contextMenuDisabledForeground: '#606068',
    flyoutLabelColor: '#a0a0a8',
    checkboxInactiveBackground: '#1a1a20',
    checkboxInactiveBorder: '#808088',
    buttonBorder: '#606068',
    buttonActiveBackground: '#1a1a20',
    buttonForeground: '#c0c0c8',
    zoomIconFilter: 'invert(100%)',
    gridColor: '#282830'
};

export {
    guiColors,
    blockColors
};
